// src/components/LearnerDashboard/CourseList.js
import { useEffect, useState } from "react";
import axios from "axios";

const AllTrainings = () => {
  const token = localStorage.getItem("token");
  const [enrolledTrainings, setEnrolledTrainings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/Training/List-For-User`, {
          headers: {
            accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        });
        setEnrolledTrainings(response.data);
      } catch (error) {
        console.error("Error fetching courses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  return { enrolledTrainings, loading };
};

export default AllTrainings;
